function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var ExtensionsManager = /*#__PURE__*/function () {
  function ExtensionsManager(config) {
    _classCallCheck(this, ExtensionsManager);
    this._extensions = {};
    for (var i in config) {
      this._extensions[i] = config[i];
    }
  }
  _createClass(ExtensionsManager, [{
    key: "addExtension",
    value: function addExtension(name, ext) {
      this._extensions[name] = ext;
    }
  }, {
    key: "getExtension",
    value: function getExtension(name) {
      return this._extensions[name];
    }
  }]);
  return ExtensionsManager;
}();
export { ExtensionsManager as default };